import { render, staticRenderFns } from "./OrdersTableDesktop.vue?vue&type=template&id=7312cb96&scoped=true"
import script from "./OrdersTableDesktop.vue?vue&type=script&lang=js"
export * from "./OrdersTableDesktop.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=7312cb96&prod&scoped=true&lang=css&external"
import style1 from "./OrdersTableDesktop.vue?vue&type=style&index=1&id=7312cb96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7312cb96",
  null
  
)

export default component.exports